// extracted by mini-css-extract-plugin
export default {"root":"style_root__2n6OZ","tips":"style_tips__1AUsm"};